/**
 * Internationalisation minimale (fr/en)
 */

const translations = {
  fr: {
    // Navigation
    'nav.home': 'Accueil',
    'nav.services': 'Prestations',
    'nav.team': 'Équipe',
    'nav.booking': 'Réserver',
    'nav.account': 'Mon compte',

    // Home
    'home.hero.title': 'Bienvenue chez EDENA',
    'home.hero.subtitle': 'Centre esthétique, 18 ans d\'expérience',
    'home.cta': 'Réserver maintenant',

    // Services
    'services.title': 'Nos prestations',
    'services.select': 'Choisir',

    // Team
    'team.title': 'Notre équipe',

    // Booking
    'booking.title': 'Réservation',
    'booking.step.service': 'Choisir une prestation',
    'booking.step.staff': 'Choisir un praticien',
    'booking.step.date': 'Choisir une date',
    'booking.step.time': 'Choisir un créneau',
    'booking.step.confirm': 'Confirmer',
    'booking.confirm': 'Confirmer la réservation',
    'booking.cancel': 'Annuler',

    // Account
    'account.login': 'Se connecter',
    'account.signup': 'S\'inscrire',
    'account.logout': 'Se déconnecter',
    'account.bookings': 'Mes réservations',
    'account.no-bookings': 'Aucune réservation',

    // Rôles
    'roles.proprietaire': 'Propriétaire',
    'roles.gerant': 'Gérant',
    'roles.employe': 'Employé',
    'roles.consultation': 'Consultation',
    'roles.client': 'Client',

    // Forms
    'form.email': 'Email',
    'form.password': 'Mot de passe',
    'form.name': 'Nom complet',
    'form.phone': 'Téléphone',
    'form.notes': 'Notes (optionnel)',

    // Messages
    'message.loading': 'Chargement...',
    'message.error': 'Une erreur est survenue',
    'message.success': 'Opération réussie',
  },
  en: {
    'nav.home': 'Home',
    'nav.services': 'Services',
    'nav.team': 'Team',
    'nav.booking': 'Book',
    'nav.account': 'My Account',

    'home.hero.title': 'Welcome to Edena',
    'home.hero.subtitle': 'Aesthetic center, 18 years of experience',
    'home.cta': 'Book now',

    'services.title': 'Our services',
    'services.select': 'Choose',

    'team.title': 'Our team',

    'booking.title': 'Booking',
    'booking.confirm': 'Confirm booking',
    'booking.cancel': 'Cancel',

    'account.login': 'Login',
    'account.signup': 'Sign up',
    'account.logout': 'Logout',
    'account.bookings': 'My bookings',
    'account.no-bookings': 'No bookings',

    // Roles
    'roles.proprietaire': 'Owner',
    'roles.gerant': 'Manager',
    'roles.employe': 'Employee',
    'roles.consultation': 'Read-only',
    'roles.client': 'Customer',

    'message.loading': 'Loading...',
    'message.error': 'An error occurred',
    'message.success': 'Operation successful',
  },
};

let currentLocale = 'fr';

/**
 * Définit la locale actuelle
 * @param {string} locale - 'fr' ou 'en'
 */
export function setLocale(locale) {
  if (translations[locale]) {
    currentLocale = locale;
    document.documentElement.lang = locale;
  }
}

/**
 * Récupère la locale actuelle
 * @returns {string}
 */
export function getLocale() {
  return currentLocale;
}

/**
 * Traduit une clé
 * @param {string} key - Clé de traduction
 * @param {object} [vars] - Variables à injecter
 * @returns {string}
 */
export function t(key, vars = {}) {
  let translation = translations[currentLocale]?.[key] || key;

  // Remplacer les variables {{var}}
  Object.keys(vars).forEach((varKey) => {
    translation = translation.replace(`{{${varKey}}}`, vars[varKey]);
  });

  return translation;
}

// Initialiser la locale depuis le navigateur
const browserLang = navigator.language.split('-')[0];
if (translations[browserLang]) {
  setLocale(browserLang);
}
